
//电子围栏坐标点
let overlays = [],
    overlaycomplete,
    drawingManager,
    map,
    myValue,
    fenceData = {},
    //电子围栏样式(画电子围栏)
    styleOptions = {
        'strokeColor': 'red', //边线颜色。
        'fillColor': '', //填充颜色。当参数为空时，圆形将没有填充效果。
        'strokeWeight': 3, //边线的宽度，以像素为单位。
        'strokeOpacity': 0.8, //边线透明度，取值范围0 - 1。
        'fillOpacity': 0.6, //填充的透明度，取值范围0 - 1。
        'strokeStyle': 'dashed' //边线的样式，solid或dashed。
    };

function initMap(initpoint){
    let point;

    map = new BMap.Map('map', {'enableMapClick':false});//构造底图时，关闭底图可点功能
    if (!initpoint) {
        point = new BMap.Point(106.556878, 29.565217); // 初始化地图,设置中心点坐标和地图级别
        map.centerAndZoom(point, 14); // 初始化地图,用城市名设置地图中心点
    } else {
        point = initpoint; // 初始化地图,设置中心点坐标和地图级别
        map.centerAndZoom(point, 16.8); // 初始化地图,用城市名设置地图中心点
    }
    map.setCurrentCity('重庆'); // 设置地图显示的城市 此项是必须设置的
    map.addControl(new BMap.ScaleControl()); //比例尺
    map.enableScrollWheelZoom();
    //setMapHeight();
}
//设置地图高度
function setMapHeight() {
    let s = $('.anchorBL').text(),
        // eslint-disable-next-line no-unused-vars
        h = 0,
        height = window.parent.document.getElementById('ir').style.height;

    // eslint-disable-next-line no-eq-null,eqeqeq
    if (height != null && height != '') {
        height = height.replace('px', '');
        // eslint-disable-next-line radix
        h = parseInt(height);
    }
    // $("#allmap").height(h);
}
/**绘制电子围栏**/
function drawManager() {
    //绘制完成事件
    overlaycomplete = function(e){
        fenceData.fenceType = e.drawingMode; //当前的绘制模式：circle(圆形)，polygon(多边形)
        if (fenceData.fenceType === 'circle') {
            fenceData.points = JSON.stringify(e.overlay.getCenter()); //圆心点
            fenceData.circleRadius = e.overlay.getRadius(); //半径
        }else{
            fenceData.points = JSON.stringify(e.overlay.getPath());
        }
        overlays.push(e.overlay);
        //打开弹窗
        showDialog(fenceData);
    };
    //实例化鼠标绘制工具
    drawingManager = new BMapLib.DrawingManager(map, {
        'isOpen': false, //是否开启绘制模式
        'enableDrawingTool': true, //是否显示工具栏
        'drawingToolOptions': {
            'anchor': BMAP_ANCHOR_TOP_RIGHT, //位置
            'offset': new BMap.Size(5, 5), //偏离值
            'scale': 0.8, //工具栏缩放比例
            'drawingModes': [
                //BMAP_DRAWING_MARKER,   //画点
                /*  BMAP_DRAWING_CIRCLE, //画圆*/
                //BMAP_DRAWING_POLYLINE,  //画线
                BMAP_DRAWING_POLYGON //画多边形
                //BMAP_DRAWING_RECTANGLE  //画矩形
            ]
        },
        'circleOptions': styleOptions, //圆的样式
        'polylineOptions':  styleOptions, //线的样式
        'polygonOptions':  styleOptions, //多边形的样式
        'rectangleOptions':  styleOptions //矩形的样式
    });
    //添加鼠标绘制工具监听事件，用于获取绘制结果
    drawingManager.addEventListener('overlaycomplete', overlaycomplete);
}

//显示电子围栏
function showFence(type,fence,fenceRadius){
    // eslint-disable-next-line no-use-before-define
    clearAll();
    let initpoint = '';

    if(type === '2'){
    //画圆第一步获取圆心点
    //获取中心点
        initpoint = new BMap.Point(fence[0].lng,fence[0].lat);
        initMap(initpoint); //重新初始化地图以第一个点为初始点
        // eslint-disable-next-line radix
        let circle = new BMap.Circle(initpoint, parseInt(fenceRadius), styleOptions); //参数：1圆心点，2半径，3样式

        map.addOverlay(circle);
    }else{
        //画多边形
        initpoint = new BMap.Point(fence[0].lng,fence[0].lat);
        initMap(initpoint); //重新初始化地图以第一个点为初始点
        let polyLine = new BMap.Polygon(fence, styleOptions);

        map.addOverlay(polyLine);
    }
}
//清除所有覆盖物
function clearAll(){
    map.clearOverlays();
    /*  for(var i = 0; i <  overlays.length; i++){
      map.removeOverlay(overlays[i]);
    }
    overlays.length = 0;*/
    drawingManager.close();
}
//关键词搜索
function searchAntistop(){
    function G(id) {
        return document.getElementById(id);
    }
    let ac = new BMap.Autocomplete( //建立一个自动完成的对象
        {'input' : 'areaName',
            'location' : map
        });

    ac.addEventListener('onhighlight', function(e) { //鼠标放在下拉列表上的事件
        let str = '',
            _value = e.fromitem.value,
            value = '';

        if (e.fromitem.index > -1) {
            value = _value.province + _value.city + _value.district + _value.street + _value.business;
        }
        str = 'FromItem<br />index = ' + e.fromitem.index + '<br />value = ' + value;

        value = '';
        if (e.toitem.index > -1) {
            _value = e.toitem.value;
            value = _value.province + _value.city + _value.district + _value.street + _value.business;
        }
        str += '<br />ToItem<br />index = ' + e.toitem.index + '<br />value = ' + value;
        // eslint-disable-next-line new-cap
        G('areaName').innerHTML = str;
    });
    ac.addEventListener('onconfirm', function(e) { //鼠标点击下拉列表后的事件
        let _value = e.item.value;

        myValue = _value.province + _value.city + _value.district + _value.street + _value.business;
        // eslint-disable-next-line new-cap
        G('areaName').innerHTML ='onconfirm<br />index = ' + e.item.index + '<br />myValue = ' + myValue;
        // eslint-disable-next-line no-use-before-define
        setPlace();
        clearAll();
    });
}
//重新定位至新的地址
function setPlace(){
    map.clearOverlays(); //清除地图上所有覆盖物
    function myFun(){
        // eslint-disable-next-line no-use-before-define
        const pp = local.getResults().getPoi(0).point; //获取第一个智能搜索的结果

        map.centerAndZoom(pp, 18);
        map.addOverlay(new BMap.Marker(pp)); //添加标注
    }
    let local = new BMap.LocalSearch(map, { //智能搜索
        'onSearchComplete': myFun
    });

    local.search(myValue);
}
//判断目标是否在多边形范围内
function ptInPolygon(point){
    let ply = new BMap.Polygon(overlays),
        result = BMapLib.GeoUtils.isPointInPolygon(point, ply);

    if (result === true) {
        // eslint-disable-next-line no-console
        console.log('在多边形范围内');
    } else {
        // eslint-disable-next-line no-console
        console.log('不在多边形范围内');
    }
}
export {
    initMap,
    searchAntistop,
    setMapHeight,
    drawManager,
    ptInPolygon,
    clearAll,
    showFence
};
